import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { CTAButton } from './CTAButton';
import { Doodles, DoodleSpec } from './Doodles';
import { ConfettiRain } from './ConfettiRain';
import { images } from '../data/bonuses';
const heroDoodles: DoodleSpec[] = [{
  kind: 'star',
  top: '5%',
  left: '4%',
  size: 28,
  color: '#F6C453',
  rotate: -8
}, {
  kind: 'confetti',
  top: '14%',
  left: '92%',
  size: 15,
  color: '#F27C70',
  rotate: 24
}, {
  kind: 'sparkle',
  top: '48%',
  left: '2%',
  size: 20,
  color: '#6CBBD5'
}, {
  kind: 'crayon',
  top: '72%',
  left: '94%',
  size: 32,
  color: '#F3A340',
  rotate: 18
}, {
  kind: 'dot',
  top: '86%',
  left: '8%',
  size: 11,
  color: '#2D8C5A'
}, {
  kind: 'sparkle',
  top: '90%',
  left: '88%',
  size: 18,
  color: '#F3A340'
}];
const tags = [{
  label: 'Manualidades',
  color: '#F27C70'
}, {
  label: 'Juegos',
  color: '#6CBBD5'
}, {
  label: 'Experimentos',
  color: '#2D8C5A'
}, {
  label: 'Retos',
  color: '#F3A340'
}];
export function Hero() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-cream" aria-labelledby="hero-title" data-id="element-136" data-mp="3o7c0y05rgtho">
      <ConfettiRain count={34} opacity={0.85} data-id="element-137" data-mp="39acuifmnb6os" />
      <Doodles specs={heroDoodles} data-id="element-138" data-mp="399jnddjryf64" />

      <div className="relative z-10 mx-auto grid max-w-content grid-cols-1 items-center gap-8 px-5 pb-11 pt-8 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-8 lg:pb-16 lg:pt-14" data-id="element-139" data-mp="39cpain8uf6z7">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-140" data-mp="30gq6jbooj7q5">
          <motion.span className="inline-flex rounded-full bg-mint px-4 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-brandgreen" animate={reduce ? undefined : {
          y: [0, -4, 0]
        }} transition={{
          duration: 3.4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-141" data-mp="35aawqhk16xes">
            365 ideas para todo el año
          </motion.span>

          <h1 id="hero-title" className="mt-5 font-display text-[2.5rem] font-extrabold uppercase leading-[0.98] tracking-tight text-navy sm:text-[3.4rem] lg:text-[4.35rem]" data-id="element-142" data-mp="2lk8usjckvr32">
            Haz del <span className="text-tangerine" data-id="element-143" data-mp="n98cdkmjmzmb">tiempo libre</span> un momento para{' '}
            <span className="text-brandgreen" data-id="element-144" data-mp="icrs51igt5ei">crear juntos</span>
          </h1>

          <p className="mt-4 max-w-md font-sans text-base leading-relaxed text-muted sm:text-lg" data-id="element-145" data-mp="degfkj0scgsl">
            365 ideas listas para jugar, crear y divertirse en casa. Solo abre, elige y
            empiezan.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-146" data-mp="162lzj3k0m1rd">
            {tags.map(t => <li key={t.label} className="rounded-full px-3 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-wide text-white" style={{
            backgroundColor: t.color
          }} data-id="element-147" data-mp="114kkctppmml6">
                {t.label}
              </li>)}
          </ul>
          <p className="mt-2 font-sans text-xs text-muted" data-id="element-148" data-mp="1x9ku2l5yd2go">Para niños de 4 a 10 años.</p>

          <div className="mt-8" data-id="element-149" data-mp="21awdg8y8grgf">
            <CTAButton data-id="element-150" data-mp="21a4ovi31ztzn">Quiero las 365 ideas</CTAButton>
          </div>

          <p className="mt-4 font-display text-[11px] font-extrabold uppercase tracking-[0.08em] text-navy/70 sm:text-xs" data-id="element-151" data-mp="26a99nkazvavo">
            + 10 bonos gratis · + Pasaporte Creativo · + Acceso inmediato
          </p>
          <p className="mt-2 font-sans text-xs text-muted" data-id="element-152" data-mp="2g0bzxcqqeaqb">Pago único • Sin suscripciones</p>
        </div>

        {/* bg-cream is required here: this element is the blend group root for the
            cut-out below, so the mockup's white studio background multiplies into
            the same cream as the landing instead of staying white. */}
        <motion.div className="relative flex justify-center bg-cream lg:justify-end" animate={reduce ? undefined : {
        y: [0, -12, 0],
        rotate: [-1.2, 1.4, -1.2]
      }} transition={{
        duration: 9,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-153" data-mp="2tysic0xyhpoa">
          <div className="absolute inset-x-12 bottom-7 h-9 rounded-[50%] bg-navy/20 blur-2xl" data-id="element-154" data-mp="4acm5ch3dp7f" />
          <img src={images.mainBook} alt="Mockup del ebook El Gran Reto Creativo, 365 ideas" className="cutout relative h-auto w-full max-w-[440px]" width={1024} height={1024} loading="eager" fetchPriority="high" decoding="sync" data-id="element-155" data-mp="3vigo07a1afyu" />
        </motion.div>
      </div>
    </section>;
}